<template>
  <div class="page-wrapper-row">
    <div class="page-wrapper-bottom">
      <div class="page-prefooter">
        <div class="container-fluid"></div>
      </div>
      <div class="page-footer">
        <div class="container-fluid"></div>
      </div>
      <div class="scroll-to-top">
        <i class="icon-arrow-up"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>
